import { gql } from "@apollo/client";
import { WarehouseLocation } from "../fragments";

const FETCH_WAREHOUSE_LOCATIONS = gql`
  query FetchWarehouseLocations($input: WarehouseLocationFilterInput) {
    warehouseLocations(input: $input) {
      ${WarehouseLocation()}
    }
  }
`;

const FETCH_SITE_LOCATIONS = gql`
  query FetchSiteLocations($input: WarehouseLocationFilterInput) {
    warehouseLocations(input: $input) {
      ${WarehouseLocation({ type: true, viewingRoom: true })}
    }
  }
`;

export { FETCH_SITE_LOCATIONS, FETCH_WAREHOUSE_LOCATIONS };
